import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';

function translateHttpLoaderFactory(
  httpBackend: HttpBackend
): TranslateHttpLoader {
  return new TranslateHttpLoader(new HttpClient(httpBackend));
}

export const TranslateConfig: TranslateModuleConfig = {
  defaultLanguage: 'en',
  loader: {
    provide: TranslateLoader,
    useFactory: translateHttpLoaderFactory,
    deps: [HttpBackend],
  },
  isolate: true,
};
